import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IAPIErrorResponse } from "../Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../Interfaces/Base/IResponse";
import { ISaveCompra } from "../Interfaces/Request/Compra/ISaveCompra";
import { IResponseCompra } from "../Interfaces/Responses/Compra/IResponseCompra";

export interface ICompraAPI {
  fetchCompra(
    data: ISaveCompra,
    hasLogin: boolean
  ): Promise<AxiosResponse<IResponse<IResponseCompra> | IAPIErrorResponse>>;
}

class CompraAPI implements ICompraAPI {
  async fetchCompra(
    data: ISaveCompra,
    hasLogin: boolean
  ): Promise<AxiosResponse<IResponse<IResponseCompra> | IAPIErrorResponse>> {
    const axios = await Http.axios();
    const response = axios.post<IResponse<IResponseCompra> | IAPIErrorResponse>(
      `/api/planos/${hasLogin ? "assinar" : "user/assinar"}`,
      data
    );
    return response;
  }
}

const instance = new CompraAPI();

export default instance;
